import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import AssetPlansPage from './pages/AssetPlansPage';
import AssetPlanPage from './pages/AssetPlanPage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AssetPlansPage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="dashboard" replace />,
      },
      {
        path: 'items',
        element: <AssetPlanPage tab="items" />,
      },
      {
        path: 'dashboard',
        element: <AssetPlanPage tab="dashboard" />,
      },
      {
        path: ':tab',
        element: <AssetPlanPage />,
      },
    ],
  },
];

export default routes;
